import '@fancyapps/fancybox';
import { fancyboxConfig } from '~/config';

$('[data-fancybox]').fancybox(fancyboxConfig);
